import React from 'react';
import Icon from '~/components/atom/Icon';
import useTooltipLayer from '~/hooks/useTooltipLayer';

const text = {
  error: 'Deze flow bevat fouten. Ga naar de flow om deze op te lossen.',
};

const ErrorsColumn: React.FC<{
  hasErrors: boolean;
}> = ({ hasErrors }) => {
  const tooltipProps = useTooltipLayer({
    tooltipMessage: text.error,
  });

  if (!hasErrors) return null;

  return (
    <Icon
      {...tooltipProps}
      strokeWidth={2.2}
      name="exclamation"
      color={{ group: 'danger' }}
    />
  );
};

export default ErrorsColumn;
